<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex flex-col">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain w-full"
			>
				<mat-icon matPrefix>search</mat-icon>
				<input
					[formControl]="search"
					[placeholder]="'reports.filter.projectsearch' | translate"
					matInput
					type="text"
				>
				<button
					(click)="search.setValue('')"
					*ngIf="search?.value"
					mat-icon-button
					matSuffix
				>
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
			<div class="mt-1 flex flex-row items-center justify-start gap-2">
				<mat-checkbox
					(click.prevent)="toggleShowCompleted()"
					[checked]="completedShown.value"
					[disabled]="completedLoading"
					color="primary"
				>
					<div class="flex items-center space-x-1">
						<span>{{ 'project.showCompleted' | translate }}</span>
						<ng-container *ngIf="completedLoading">
							<mat-progress-spinner
								[diameter]="14"
								[strokeWidth]="2"
								class="-mt-1"
								mode="indeterminate"
							></mat-progress-spinner>
						</ng-container>
					</div>
				</mat-checkbox>
				<div class="!ml-auto flex flex-row items-center justify-start">
					<div
						(click)="this.selectAll()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.all
					</div>
					<div
						(click)="this.selectNone()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.none
					</div>
				</div>
			</div>
			<div class="-mx-16px"><mat-divider inset></mat-divider></div>
			<mat-list class="-mx-16px pt-0">
				<cdk-virtual-scroll-viewport
					[itemSize]="48"
					class="h-64"
				>
					<mat-list-item
						(click)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						(keydown.enter)="$event.preventDefault(); $event.stopPropagation(); this.close()"
						(keydown.space)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						*cdkVirtualFor="let item of items$filtered.value$ | async; trackBy: trackId"
						class="cursor-pointer"
						matRipple
					>
						<div class="flex-mw flex flex-1 items-center space-x-2">
							<mat-checkbox
								[checked]="item.selected"
								class="mat-checkbox-flex"
								color="primary"
							></mat-checkbox>
							<span
								[style.backgroundColor]="item.color"
								*ngIf="!item.useAsDefault"
								class="project-color-dot flex-shrink-0 !cursor-default !mr-0"
							></span>
							<div
								*ngIf="item.useAsDefault"
								class="w-3"
								matPrefix
							></div>
							<div class="l-initial mat-truncate flex flex-1 flex-col">
								<span
									[innerHTML]="item | defaultEntityTranslate: 'project' : 'project.none' : null : true"
									class="mat-truncate"
								></span>
								<span
									*ngIf="item.client"
									class="mat-truncate mat-hint text-sm leading-none"
									>{{
										item.client | defaultEntityTranslate: 'client' : 'client.none'
									}}</span
								>
							</div>
							<div
								[matTooltip]="'project.completed' | translate"
								*ngIf="item.completed"
								class="text-green-500 mat-size-6 dark:text-green-400"
							>
								<mat-icon inline>check_circle</mat-icon>
							</div>
							@if (item.estimation > 0) {
							<app-estimation-statistics-graph
								[completed]="item.completed"
								[estimation]="item.estimation || 0"
								[recorded]="
										item.timesRecorded
											? (item.timesRecorded.billable?.clamp(0, item.timesRecorded.billable) || 0) +
											(!item.billable
												? item.timesRecorded.notBillable?.clamp(0, item.timesRecorded.notBillable) || 0
												: 0)
											: 0
										"
								class="mb-1"
							></app-estimation-statistics-graph>
							}
						</div>
					</mat-list-item>
				</cdk-virtual-scroll-viewport>
			</mat-list>
		</mat-card>
	</div>
</ng-template>
